module.exports = __webpack_public_path__ + "static/img/frack01.4f4070f7.png";